import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import { requireAuth, closeSheets } from './middleware'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(closeSheets)
router.beforeEach(requireAuth)

export default router
